import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "card-body" };
const _hoisted_2 = { class: "body2-text text-black" };
const _hoisted_3 = { class: "body2-text text-black" };
const _hoisted_4 = { class: "inner-box" };
const _hoisted_5 = { class: "body2-text text-black" };
const _hoisted_6 = { class: "body2-text text-black" };
const _hoisted_7 = { class: "body2-text text-black" };
const _hoisted_8 = { class: "body2-text text-black" };
const _hoisted_9 = { class: "body2-text text-black" };
const _hoisted_10 = { class: "body2-text text-black" };
const _hoisted_11 = { class: "body2-text text-black" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_InputRow = _resolveComponent("InputRow");
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_Chip = _resolveComponent("Chip");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createCommentVNode(" 본사 계약 설정 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}adjustment_type_setting`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.detail.formattedAdjustmentType), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 관리비 유형 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}delivery_pay_flag`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.detail.formattedDeliveryPayFlag), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.validatedFilteredDeliveryPayFlagList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                    key: `store_detail_${index}`
                }, [
                    _createVNode(_component_InputRow, {
                        label: item.text[_ctx.detail.deliveryPayFlag],
                        "wide-title": ""
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.detail[item.value]), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label"])
                ]));
            }), 128 /* KEYED_FRAGMENT */))
        ]),
        _createVNode(_component_v_divider, { class: "divider" }),
        _createCommentVNode(" 건강 상점 수수료 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}delivery_fee_per_order`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.deliveryFeeRate), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_v_divider, { class: "divider" }),
        _createCommentVNode(" 운행거리배율 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}distance_product`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.detail.formattedDistanceProduct), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 대행료 결제방식 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}delivery_pay_type`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createVNode(_component_Chip, {
                    text: _ctx.deliveryPayType[_ctx.detail.deliveryPayType].text,
                    "brg-chip-color": _ctx.deliveryPayType[_ctx.detail.deliveryPayType].color
                }, null, 8 /* PROPS */, ["text", "brg-chip-color"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 대행료 부가세 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}vat_rate`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.detail.formattedVatRate), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 선차감 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}hub_delivery_prepayment_fee`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.hubPrepaymentFee), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 상품가 할증 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}goods_price_surcharge`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.detail.formattedGoodsPriceSurchargeInfoDTOListCount), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 상점 그룹별 라이더 수수료 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}worker_fee_per_store_group`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.detail.validatedWorkerFeePerStoreGroupName), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"])
    ]));
}
